import tippy, { Props as TippyProps } from 'tippy.js';
// TODO: Figure out types to use SingleTarget and MultipleTargets from tippy.js

/**
 * Initialize Tippy tooltips
 * @param elem Optional target(s) to initialize tippy on, otherwise does all elements with data-tippy-content
 */
export default (theme: string = '', target?: any) => {
  const options = {
    arrow: true,
    placement: 'bottom',
    theme: theme,
    maxWidth: 295,
    allowHTML: true,
    // theme: 'reids',
    offset: [0, 15],
  } as TippyProps;

  if (target) {
    tippy(target, options);
  } else {
    tippy('[data-tippy-content]', options);
  }
};
